<template>
  <div class="repair-container" ref="scrollBar" @click="showMiniMenu = false">
    <div class="repair-header" v-if="!$route.query.t">
      <div class="repair-nav repair-layout">
        <div class="repair-logo">
          <img src="@/assets/imgs/logo.svg" alt="" />
        </div>
        <div class="repair-menu">
          <div
            class="repair-menu-item"
            v-for="menu in menuData"
            :key="menu.value"
            :class="{ 'repair-nav-activeMenu': $route.meta.key === menu.value }"
            @click="toRouter(menu)"
          >
            <p class="font-format-normal">{{ menu.label }}</p>
          </div>
        </div>
      </div>
      <i
        class="repair-mini-menu-switch el-icon-menu"
        :class="!showMiniMenu ? 'el-icon-menu' : 'el-icon-close'"
        @click.stop="showMiniMenu = !showMiniMenu"
      ></i>
      <div class="repair-mini-menu" v-if="showMiniMenu">
        <p
          v-for="menu in menuData"
          :key="menu.value"
          :class="{ 'repair-nav-activeMenu': $route.meta.key === menu.value }"
          @click.stop="toRouter(menu)"
          class="font-format-normal"
        >
          {{ menu.label }}
        </p>
      </div>
    </div>
    <div class="repair-main">
      <div class="repair-view repair-layout">
        <router-view />
      </div>
    </div>
    <!-- <div class="repair-footer">
      <p class="font-format-small">
        Copyright © 2018 Onyx International Inc. All rights reserved.
        粤ICP备12049135号
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "repair",
  provide() {
    return {
      scrollTo: this.scrollTo,
    };
  },

  computed: {
    menuData() {
      return [
        {
          label: "自助寄修",
          value: "RepairReq",
        },
        {
          label: "服务进度",
          value: "RepairTrace",
        },
        {
          label: "旧售后项目",
          value: "OldProject",
        },
        {
          label: "更新寄修快递",
          value: "RepairUpdate",
        },
        {
          label: "开票",
          value: "Invoice",
        },
      ];
    },
  },
  data() {
    return {
      showMiniMenu: false,
    };
  },
  methods: {
    scrollTo(val) {
      this.$refs.scrollBar.scrollTop = val;
    },
    toRouter(menu) {
      if (menu.value === "OldProject") {
        window.open("https://send2boox.com/o/d/", "_blank");
        return;
      }
      if (menu.value === this.$route.name) return;
      this.$router.push({ name: menu.value });
      this.showMiniMenu = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.repair-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background: #f8f8f8;
  .repair-header {
    width: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 20px;
    margin-bottom: 20px;
    /* overflow: hidden; */
    box-shadow: 0 2px 10px -3px #979797;
    position: relative;
    .repair-nav {
      height: 100%;
      display: flex;
      align-items: center;
      .repair-logo {
        margin-right: 50px;
      }
      .repair-menu {
        display: flex;
        height: 100%;
        align-items: center;
        .repair-menu-item {
          cursor: pointer;
          height: 100%;
          margin-right: 40px;
          display: flex;
          align-items: center;
        }
      }
    }
    .repair-nav-activeMenu {
      color: $themeColor;
      border-bottom: 2px solid $themeColor;
    }
    .repair-mini-menu-switch {
      font-size: 24px;
      color: $textColor1;
      cursor: pointer;
      position: absolute;
      left: 20px;
      top: 12px;
      display: none;
    }
    .repair-mini-menu {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background: #fff;
      z-index: 1000;
      border-top: 1px solid #ccc;
      > p {
        text-align: center;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        cursor: pointer;
      }
    }
  }
  .repair-main {
    flex: 1;
    width: 100%;
    /* display: flex; */

    padding: 0 0 20px;
    .repair-view {
      display: flex;
      /* background: #fff; */
    }
  }
  .repair-footer {
    text-align: center;
    width: 100%;
    padding: 10px;
  }
}

@media (max-width: 700px) {
  .repair-nav {
    .repair-logo {
      margin: 0 auto !important;
    }
    .repair-menu {
      display: none !important;
    }
  }
  .repair-mini-menu-switch {
    display: block !important;
  }
  .repair-main {
    padding-bottom: 60px !important;
  }
}
</style>
